import Checkbox from "../../../CheckBox/CheckBox";
import React, { useState } from "react";
import Button from "../../../Button/Button";
import Modal from "../../../Modal/Modal";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router";
const SummaryStep = ({
  location,
  setActiveStep,
  setSubActiveStep,
  massageCardsData,
  performanceData,
  bodyTransformationData,
  cuppingTherapyData,
  advancedElectroMuscularData,
  manipulativeTherapyData,
  physiotherapyData,
  acupunctureData,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const navigate = useNavigate();
  const termsAndConitions = [
    {
      heading: "INDEPENDENTLY OWNED AND OPERATED LOCATIONS",
      description:
        "SILC® LOCATION is independently owned and operated. SILC® is the trading name of RJButterfly Ltd. membership agreements and wellness agreements are with the person or entity that owns the location.",
    },
    {
      heading: "MEMBERSHIP PRICE CHANGES",
      description:
        "Following the initial term of your membership or Wellness Agreement, the members will give 30 days advance written notice of any increase in the monthly payment (or membership dues) under your membership or Wellness agreement. Membership is subject to annual increase at date of renewal to reflect rate of inflation.",
    },
    {
      heading: "SERVICE DETAILS AND REQUIREMENTS",
      description:
        "In line with best practices, only professional therapists and aestheticians and clinical practitioners who comply with state, city, and/or local licensing or certification requirements are hired by the SILC. You understand that the services SILC provides are not a replacement for primary medical care, should not be construed as a substitute for hospital appointment and or examination. However, our clinically approved physiotherapist are able to diagnose musculoskeletal conditions and make recommendations and referrals and provide rehabilitative care, or treatment intervention. No systemic health related medical diagnosis will be made, and all findings will be suggestive for referral for you to seek you general practitioner for any medical issues you may have. It is your responsibility to inform the SILC location or visiting therapist of any pre-existing conditions, limitations, or specific sensitivities.",
      description1:
        "SILC would love to have a long-lasting relationship with our members based on mutual respect and trust. And Although we aim to please, often we get request that we cannot accommodate.",
    },
    {
      heading: "SERVICE DETAILS",
      description:
        "Treatments such as trigger point therapy, sports massage can be painful within the acute and chronic phase and could have residual ache	post treatment or leave you feeling sore or bruised. Post treatment effects of acupuncture or manipulative therapy can have delayed affect soreness lasting 24-96 hours. Most other therapy offered should not present pain. Exercise due to the increase of lactic acid build up within the muscle will produce a burn effect at level of fatigue with the residual affect being felt in the muscles the following day(s). If you do experience discomfort or pain or any discomfort of any kind during you service, you agree to immediately ask the therapist or aesthetician or clinical practitioner to adjust the temperature, pressure, manipulation technique, draping, heat, or environment (or, if you prefer, you can ask the therapist or aesthetician to end the service at any time if feeling unwell). If the therapist or aesthetician is unable to relieve your discomfort after you request an adjustment, you will inform the therapist or aesthetician or clinical practitioner you would like to seek medical attention.",
      description2:
        "If you have any concerns about your therapist or aesthetician, or clinical practitioner you agree to bring it to the attention of the person rendering the service immediately following your service.",
      description3:
        "Inappropriate or illegal or racial prejudice conduct will not be tolerated in any manner between the service provider and client. The service provider SILC may, in its sole discretion, refuse or discontinue a service to you if it determines such actions cause injury to feelings of the service provider or if practitioner service are deemed to be unsafe or cause discomfort for you or if you engage in any inappropriate conduct as determined by Brand SILC in its sole discretion to terminate services as we seek to resolve the matters arising.",
    },
  ];

  const frequency = {
    once: "Once a week",
    twice: "Twice a week",
  };

  let summary = [];
  if (!!massageCardsData?.length) {
    summary = [
      ...summary,
      {
        index: 2,
        subIndex: 0,
        serviceName: "Massage Therapy",
        price:
          massageCardsData?.reduce((prev, { charge }) => prev + charge, 0) || 0,
        package: massageCardsData
          ?.filter(({ charge }) => charge)
          ?.map((item) => {
            return {
              packageName: item?.name?.toUpperCase(),
              packageDetail: [
                item?.headNeck?.isChecked
                  ? `Head, neck & shoulders - ${frequency[item?.frequency]}`
                  : false,
                item?.fullBack?.isChecked
                  ? `Full back - ${frequency[item?.frequency]}`
                  : false,
                item?.lowerBack?.isChecked
                  ? `Lower back & glutes & shoulders - ${
                      frequency[item?.frequency]
                    }`
                  : false,
                item?.thighLegs?.isChecked
                  ? `Thighs & legs - ${frequency[item?.frequency]}`
                  : false,
              ]?.filter(Boolean),
            };
          }),
      },
    ];
  }
  if (!!performanceData?.length) {
    summary = [
      ...summary,
      {
        index: 2,
        subIndex: 1,
        serviceName: "Performance Mobility Therapy",
        price:
          performanceData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
        package: performanceData
          ?.filter(({ isChecked }) => isChecked)
          ?.map((item) => {
            return {
              packageName:
                item?.focusArea + " - (" + item.therapyDuration + ")",
            };
          }),
      },
    ];
  }
  if (!!bodyTransformationData?.length) {
    summary = [
      ...summary,
      {
        index: 2,
        subIndex: 2,
        serviceName: "Body Transformation",
        price:
          bodyTransformationData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
        package: bodyTransformationData
          ?.filter(({ isChecked }) => isChecked)
          ?.map((item) => {
            return {
              packageName:
                item?.package +
                (item.sessions ? " - " + item.sessions + " sessions" : ""),
            };
          }),
      },
    ];
  }
  if (!!cuppingTherapyData?.length) {
    summary = [
      ...summary,
      {
        index: 2,
        subIndex: 3,
        serviceName: "Performance Mobility Therapy",
        price:
          cuppingTherapyData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
        package: cuppingTherapyData
          ?.filter(({ isChecked }) => isChecked)
          ?.map((item) => {
            return {
              packageName: item?.focusArea,
            };
          }),
      },
    ];
  }
  if (!!advancedElectroMuscularData?.length) {
    summary = [
      ...summary,
      {
        index: 2,
        subIndex: 4,
        serviceName: "Advanced Electro Muscular Therapy",
        price:
          advancedElectroMuscularData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
        package: advancedElectroMuscularData
          ?.filter(({ isChecked }) => isChecked)
          ?.map((item) => {
            return {
              packageName: item?.focusArea,
              packageDetail: [
                item?.duration + " - " + frequency[item?.frequency],
              ],
            };
          }),
      },
    ];
  }
  if (!!manipulativeTherapyData?.length) {
    summary = [
      ...summary,
      {
        index: 2,
        subIndex: 5,
        serviceName: "Manipulative Medicine",
        price:
          manipulativeTherapyData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
        package: manipulativeTherapyData
          ?.filter(({ isChecked }) => isChecked)
          ?.map((item) => {
            return {
              packageName: item?.type,
            };
          }),
      },
    ];
  }
  if (!!physiotherapyData?.length) {
    summary = [
      ...summary,
      {
        index: 2,
        subIndex: 6,
        serviceName: "Physiotherapy",
        price:
          physiotherapyData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
        package: physiotherapyData
          ?.filter(({ isChecked }) => isChecked)
          ?.map((item) => {
            return {
              packageName: item?.type,
            };
          }),
      },
    ];
  }
  if (!!acupunctureData?.length) {
    summary = [
      ...summary,
      {
        index: 2,
        subIndex: 7,
        serviceName: "Acupuncture",
        price:
          acupunctureData
            ?.filter((item) => item.isChecked)
            ?.reduce((prev, { price }) => prev + price, 0) || 0,
        package: acupunctureData
          ?.filter(({ isChecked }) => isChecked)
          ?.map((item) => {
            return {
              packageName: item?.type,
            };
          }),
      },
    ];
  }
  const membershipHandler = () => {
    axios
      .post(`${process.env.REACT_APP_API_PATH}/user/membership`, summary, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Membership Confirmed Successfully",
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            navigate("/", { replace: true });
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div>
      <p className="font-font-Titillium font-normal text-[22px] text-[#262626] text-center leading-[33px] tracking-[0.0094em] mt-10 mb-2">
        Please review your plan and make any changes if required:
      </p>

      <div className="overflow-x-auto md:overflow-x-visible rounded-xl">
        <div className="w-[628px] md:w-full">
          <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040] h-[392px] py-6 pl-6 pr-4">
            <div className="h-[340px] overflow-y-scroll scrollbar">
              <p className="font-font-Titillium font-semibold text-[18px] text-[#141414] leading-[23.4px] tracking-[0.0313] uppercase mb-4">
                Your Treatment Location Details
              </p>
              <div className="grid grid-cols-10 gap-2 items-center">
                <p className="col-span-7 font-font-Titillium font-normal text-[16px] text-[#262626] leading-[20.8px] tracking-[0.0156em]">
                  Treatment at {location?.name || "N/A"}
                </p>
                <p className="col-span-1 font-font-Titillium font-normal text-[14px] text-[#262626] leading-[16.8px] tracking-[0.025]">
                  £{location?.price || 0}
                </p>
                <button
                  className="col-span-2 font-font-Titillium font-semibold text-[16px] text-[#FAAD14] leading-[21px] tracking-[0.0156em]"
                  onClick={() => setActiveStep(1)}
                >
                  Edit
                </button>
              </div>
              <div className="border border-solid border-[#8C8C8C] mb-6 mt-4 w-[98%]"></div>
              <p className="font-font-Titillium font-semibold text-[18px] text-[#141414] leading-[23.4px] tracking-[0.0313] uppercase mb-4">
                Your Treatment Options Details
              </p>
              {summary?.map((item) => (
                <div className="mb-4">
                  <div
                    className={`grid grid-cols-10 gap-2 items-center h-[24px]`}
                  >
                    <p className="col-span-7 font-font-Titillium font-normal text-[16px] text-[#8C8C8C] leading-[17px] tracking-[0.0156em] uppercase">
                      {item?.serviceName}
                    </p>
                    <p className="col-span-1 font-font-Titillium font-normal text-[14px] text-[#262626] leading-[16.8px] tracking-[0.025] justify-center">
                      £{item?.price}
                    </p>
                    <button
                      className="col-span-2 font-font-Titillium font-semibold text-[16px] text-[#FFC53D] hover:text-[#FAAD14] leading-[21px] tracking-[0.0156em]"
                      onClick={() => {
                        setActiveStep(item?.index);
                        setSubActiveStep(item?.subIndex);
                      }}
                    >
                      Edit
                    </button>
                  </div>
                  {!!item?.package?.length &&
                    item?.package?.map((pack) => (
                      <>
                        <p
                          className={`font-font-Titillium font-normal text-[16px] text-[#262626] leading-[20.8px] tracking-[0.0156em] flex my-1 h-[${
                            !!pack?.packageDetail?.length
                              ? `${
                                  24 *
                                  (pack?.packageDetail?.length > 1
                                    ? pack?.packageDetail?.length
                                    : 2)
                                }px`
                              : "24px"
                          }] ${pack?.packageName ? "items-center" : ""}`}
                        >
                          {pack?.packageName}
                          {!!pack?.packageName && <br />}
                          {!!pack?.packageDetail?.length &&
                            pack?.packageDetail?.map((packDetail) => (
                              <>
                                {packDetail}
                                <br />
                              </>
                            ))}
                        </p>
                        {/* {!!pack?.packageDetail?.length &&
                          pack?.packageDetail?.map((packDetail) => (
                            <p
                              className={`font-font-Titillium font-normal text-[16px] text-[#262626] leading-[20.8px] tracking-[0.0156em] flex ${packDetail ? "items-center" : ""}`}
                            >
                              {packDetail}
                            </p>
                          ))} */}
                      </>
                    ))}
                  {!item?.package?.length && (
                    <p
                      className={`font-font-Titillium font-normal text-[16px] text-[#262626] leading-[20.8px] tracking-[0.0156em] flex h-[24px] items-center`}
                    >
                      Not Selected
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
          {/* Total Charge */}
          <div className="border-[#D9D9D9] border border-solid rounded-xl shadow-[0px_0px_7px_#00000040] my-2 h-[56px] grid grid-cols-10">
            <div className="col-span-7 flex items-center pl-6">
              <p className="font-font-Titillium font-semibold text-[16px] leading-[20.8px] tracking-[0.0156em] uppercase text-[#141414]">
                Total Charge:
              </p>
            </div>
            <div className="col-span-1 flex items-center ">
              <p className="font-font-Titillium font-semibold text-[18px] leading-[27px] tracking-[0.0313] text-center">
                £
                {summary?.reduce((prev, curr) => prev + curr?.price, 0) +
                  location?.price || 0}
              </p>
            </div>
            <div className="col-span-2"></div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-10 mt-20">
        <Checkbox
          id="terms"
          label={
            <p>
              I hereby confirm that I have read and <br />
              agree to the{" "}
              <strong
                onClick={() => setShowTerms(true)}
                className="hover:cursor-pointer"
              >
                Terms & Conditions
              </strong>
            </p>
          }
          divStyle="col-span-5"
          onChecked={(e) => setIsChecked(e)}
          isChecked={isChecked}
        />
        <Button
          name={"Confirm Membership > "}
          classNames="h-12 w-[302px] disabled:bg-[#D9D9D9] disabled:cursor-not-allowed hover:bg-[#FFC53D]"
          divStyle="col-span-5 justify-center sm:justify-end"
          disabled={!isChecked}
          onClickHandler={membershipHandler}
        />
      </div>
      <Modal show={showTerms}>
        <div className="pt-10 px-14 pb-4 h-24">
          <p className="font-font-Montserrat font-semibold text-[34px] text-[#FAAD14] leading-[44.2px] tracking-[0.0156em]">
            Membership Terms & Conditions
          </p>
        </div>
        <div className="h-[416px] overflow-y-scroll scrollbar border border-solid border-[#D9D9D9] shadow-[0px_1px_5px_#00000040] px-14 py-8">
          {termsAndConitions?.map((terms) => (
            <div>
              <p className="font-font-Titillium font-semibold text-[18px] text-[#262626] leading-[23.4px] tracking-[0.0313] uppercase mb-2">
                {terms?.heading}
              </p>
              <p className="font-font-Titillium font-light text-[16px] text-[#262626] leading-[20.8px] tracking-[0.0156] mb-6">
                {terms?.description}
                {!!terms?.description2 && <br />}
                {terms?.description2}
                {!!terms?.description3 && <br />}
                {terms?.description3}
              </p>
            </div>
          ))}
        </div>
        <div className="h-[80px] flex items-center justify-end shadow-[0px_1px_24px_8px_#14141414]">
          <Button
            name="OK"
            classNames="w-[100px] hover:bg-[#FFC53D]"
            divStyle="pr-4"
            onClickHandler={() => setShowTerms(false)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default SummaryStep;
